// extracted by mini-css-extract-plugin
export default {"Panel":"LocalizedTextInput_Panel__wXd2O","Tabs":"LocalizedTextInput_Tabs__-H7eW"};